import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface ITextareaProps {
  title: string;
  textarea: React.ReactNode;
  counter?: React.ReactNode;
}

export const TextareaReview = ({ title, textarea, counter }: ITextareaProps): React.JSX.Element => {
  return (
    <div>
      <div className={styles['title']}>
        <UIText2>{title}</UIText2>
      </div>
      <div className={styles['textarea']}>{textarea}</div>
      {counter}
    </div>
  );
};
